import { useQuery } from '@tanstack/react-query';
import { planApi } from '@features/plans/api/plan.api';

export const planKeys = {
  all: ['plans'] as const,
  list: () => [...planKeys.all, 'list'] as const,
};

export function usePlans() {
  return useQuery({
    queryKey: planKeys.list(),
    queryFn: planApi.list,
  });
}
